export async function generateAllInsights(
  quizData,
  force,
  currentOverview,
  currentIndividual,
  generateProfileOverviewFn,
  generateIndividualInsightsFn
) {
  if (!quizData || quizData.length === 0) {
    const details = {
      passedData: !!quizData,
      passedDataLength: quizData?.length || 0,
    };
    console.error("❌ generateAllInsights: No quiz data available", details);
    throw new Error("No completed quiz data available to analyze");
  }

  console.log(
    "🔄 Starting generateAllInsights with",
    quizData.length,
    "quizzes"
  );
  console.log(
    "📊 Quiz data summary:",
    quizData.map((q) => ({
      type: q.quizType,
      hasResults: !!q.results,
      resultsCount: q.results?.length || 0,
      hasInsights: !!q.insights,
    }))
  );

  const needsOverview = !currentOverview || force;
  const needsIndividual =
    Object.keys(currentIndividual || {}).length < quizData.length || force;

  console.log("🎯 Generation plan:", {
    needsOverview,
    needsIndividual,
    currentOverview: currentOverview ? "Exists" : "Missing",
    currentIndividualCount: Object.keys(currentIndividual || {}).length,
    totalQuizzes: quizData.length,
  });

  console.log("⚡ Starting Promise.all for insights generation...");

  const [overview, individual] = await Promise.all([
    needsOverview
      ? (async () => {
          console.log("🧠 Calling generateProfileOverview...");
          try {
            const result = await generateProfileOverviewFn(quizData);
            console.log("✅ generateProfileOverview completed:", !!result);
            return result;
          } catch (err) {
            console.error("❌ generateProfileOverview failed:", err);
            throw new Error(`Profile overview: ${err.message}`);
          }
        })()
      : Promise.resolve(currentOverview),
    needsIndividual
      ? (async () => {
          console.log("🔍 Calling generateIndividualInsights...");
          try {
            const result = await generateIndividualInsightsFn(quizData);
            console.log(
              "✅ generateIndividualInsights completed:",
              Object.keys(result).length,
              "insights"
            );
            return result;
          } catch (err) {
            console.error("❌ generateIndividualInsights failed:", err);
            throw new Error(`Individual insights: ${err.message}`);
          }
        })()
      : Promise.resolve(currentIndividual),
  ]);

  console.log("✅ Promise.all completed successfully");
  console.log("✅ Generation results:", {
    hasOverview: !!overview,
    individualCount: Object.keys(individual).length,
    overviewGenerated: needsOverview,
    individualGenerated: needsIndividual,
  });

  return { overview, individual };
}
